"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processSubNavContent = exports.buildButtonUrl = exports.appendLinkNav = void 0;
var _dtmConsts = require("./dtmConsts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var appendLinkNav = exports.appendLinkNav = function appendLinkNav(url, navType) {
  /*
  INPUT: incoming params:
    url === 'http://test.com/page-1'
    navType === 'linknav' or 'intlink' or any arbitary custom type
    rest === subsequent params
  OUTPUT:
    http://test.com/page-1?linknav=quantacard-compare-greencard
  */

  var urlVal = String(url).replace(/ /g, '');
  var navCode = typeof navType === 'string' && navType.length > 0 ? navType : _dtmConsts.DTM_CONSTS.defaultNavType;
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  if (rest.length <= 0) {
    return urlVal;
  }
  var regex = new RegExp("(\\?|\\&)".concat(navCode.toLowerCase(), "="));
  if (urlVal.toLowerCase().search(regex) > -1) {
    return urlVal;
  }
  urlVal += urlVal.indexOf('?') <= -1 ? '?' : '';
  urlVal += urlVal.endsWith('?') === false && urlVal.endsWith('&') === false ? '&' : '';
  urlVal += "".concat(navCode, "=");
  urlVal += rest.reduce(function (prevVal, currVal) {
    if (!currVal) {
      return prevVal;
    }
    return prevVal ? "".concat(prevVal, "-").concat(currVal) : currVal;
  }, '');
  return urlVal;
};
var buildButtonUrl = exports.buildButtonUrl = function buildButtonUrl(linkObj) {
  var pageDtmInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var productName = arguments.length > 2 ? arguments[2] : undefined;
  var section = arguments.length > 3 ? arguments[3] : undefined;
  if (!linkObj || !linkObj.url) {
    return '';
  }
  var eventAsset = linkObj.dtm && linkObj.dtm.eventAsset ? linkObj.dtm.eventAsset : undefined;
  var navTypeRaw = linkObj.dtm && linkObj.dtm.eventAction ? linkObj.dtm.eventAction : '';
  var navType = [_dtmConsts.DTM_CONSTS.defaultNavType, _dtmConsts.DTM_CONSTS.intLinkNavType].includes(navTypeRaw) ? navTypeRaw : _dtmConsts.DTM_CONSTS.defaultNavType;
  var resultUrl = appendLinkNav(linkObj.url, navType, pageDtmInfo.linkNavBase, productName, section, eventAsset);
  return resultUrl;
};
var processSubNavContent = exports.processSubNavContent = function processSubNavContent(contentList, navBaseVal) {
  /*
    expected incoming structure:
    [
      {
        content [
          {
            content [
              { ... same struct },
              { ... same struct }
            ],
            dtmTag { tag, type },
            url: '/deep-level/page-name.html'
          },
          { ... same struct }
        ],
        dtmTag { tag, type },
        url: '/au/business/business-credit-cards/platinum-business-card'
      },
      {
        content [
          { ... same struct },
          { ... same struct }
        ],
        dtmTag { tag, type },
        url: '/au/business/business-credit-cards/platinum-business-card'
      },
      ...
    ]
  */

  if (!Array.isArray(contentList)) {
    return contentList;
  }
  return contentList.map(function (item) {
    var _ref = item.dtmTag || {},
      tag = _ref.tag,
      type = _ref.type;
    var urlVal = item.url && tag && type ? appendLinkNav(item.url, type, navBaseVal, tag) : item.url;
    var childList = Array.isArray(item.content) === true ? processSubNavContent(item.content, navBaseVal) : item.content;
    return _objectSpread(_objectSpread({}, item), {}, {
      url: urlVal,
      content: childList
    });
  });
};